module.exports = __webpack_public_path__ + "static/media/sofia-idle.bcc4940e.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/sofia-idle.png
// module id = 44
// module chunks = 0